import React, { useState, useEffect } from "react";
import ReactExport from "react-data-export";
import Styles from './Styles';
import IconButton from '../../../buttons/IconButton';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const Download = props => {
    const [ dataSet, setDataSet ] = useState([{
        columns:[],
        data:[]
    }]);

    useEffect(() => {
        formatData();
    },[props.data])

    if (props.loading) {
        return null
    };

    const formatData = () => {
        let label;
        if (props.data.length > 0) {
            label = Object.keys(props.data[0]);
        } else {
            label = Object.keys([]);
        };
    
        const columns = label.reduce((r,i) => {
            r.push({
                title:i, 
                style:Styles.shippingDetailLabelStyle
            });
            return r;
        },[]);

        let style = Styles.shippingDetailRowLightStyle;
        const data = props.data.reduce((r,i,idx) => {
            r.push([
                {value:i.no || "", style},
                {value:i.reference_id || "", style},
                {value:i.amount || "", style},
                {value:i.currency || "", style},
                {value:i.description || "", style},
                {value:i.payment_category || "", style},
                {value:i.payment_method || "", style},
                {value:i.type || "", style},
                {value:i.status || "", style},
                {value:i.created_at || "", style},
                {value:i.created_date || "", style},
                {value:i.created_time || "", style}
            ]);
            return r;
        },[])
        setDataSet([{
            columns,
            data
        }])
    }

    return (
            <ExcelFile 
                filename={props.filename} 
                element={
                    <IconButton iconClassName="fas fa-file-download" className="btn-secondary border">
                        Export
                    </IconButton>
                }
            >
                <ExcelSheet dataSet={dataSet} name="Transaction Details"/>
            </ExcelFile>
    );
}

export default Download;